import { useMutation } from 'react-query';

import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import { postV2ApiCompanyIdBookkeepingSpainClosurePeriodsClearClosureErrors } from 'src/client/spendesk-api';
import type { PostV2ApiCompanyIdBookkeepingSpainClosurePeriodsClearClosureErrorsRequest } from 'src/client/spendesk-api-types';

export const useClearSpainClosureErrors = () => {
  const companyId = useCompanyId();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: async (
      payload: PostV2ApiCompanyIdBookkeepingSpainClosurePeriodsClearClosureErrorsRequest['body'],
    ) => {
      const response =
        await postV2ApiCompanyIdBookkeepingSpainClosurePeriodsClearClosureErrors(
          {
            path: { companyId },
            body: payload,
          },
        );

      switch (response.statusCode) {
        case 200:
          return response.body;
        case 400:
          throw new Error('Invalid body parameters');
        case 401:
          throw new Error(response.body.reason);
        case 403:
          throw new Error(response.body.reason ?? 'Forbidden');
        case 404:
          throw new Error(response.body.reason);
        case 409:
          throw new Error(response.body.reason);
        case 422:
          throw new Error(response.body.reason ?? 'Unprocessable entity');
        default:
          throw new Error('Failed to clear Spain closure errors');
      }
    },
  });

  return {
    clearSpainClosureErrors: mutateAsync,
    isPending: isLoading,
  };
};
